import {DigitizationTools} from "../ToolRegistry.js";

import {T} from "../i18n/index.js";
// "Graverapport" i Rapporter: automatisk udgravnings-/påfyldningsvolumen for en punktsky - uden at digitalisere noget. Værktøjet
// registrerer intet i Registreringer-træet; det beder blot værten (PointViews frontend) åbne graverapport-dialogen, som
// beregner for den aktivt indlæste punktsky (én: straks; flere: vælg blandt de indlæste) på de grove oktræ-niveauer
// (modules/CutFillVolume/CutFillJob.js) og gemmer rapporten som PDF. (Selve beregningen kan også køre på en punktsky, der ikke er
// indlæst - det bruges bare ikke af dialogen.) På sigt kan den samme beregning køre som job og skrive
// samme cut_fill_volume.json; dialogen viser så et eksisterende resultat i stedet for at beregne.
export const GraveReportTool = {
	id: "digitize_grave_report",
	name: T("Graverapport"),
	category: "reports",
	kind: "measurement",
	toolbarGroup: "report",
	toolbarOrder: 20,
	icon: "cut_fill_volume.svg",
	resultGeometryType: "Point",
	featureType: T("Graverapport"),
	tooltip: T("Beregn udgravning og påfyldning automatisk for den indlæste punktsky og gem en graverapport som PDF."),

	customCapture(dm){
		// intet at digitalisere: værktøjet er en handling, ikke en optagelse
		dm.stopInsertion();
		dm.dispatchEvent({type: "open_grave_report_requested"});
	},
};

DigitizationTools.register(GraveReportTool);
